import { Accordion, Grid, Timeline } from '@design-systems/canvas-ui'
import { useStoreTrailerEta } from 'hooks/trailer/useStoreTrailerEta'
import { useEssentials } from 'hooks/utils/useEssentials'
import { format, parseISO } from 'date-fns'
import { ErrorAlert } from 'components/error-fallback'
import { BasicPlaceholder } from 'components/placeholder'
import useCountdown from 'hooks/utils/useCountdown'

export const TrailerEta = (moveId: any) => {
    const { env, session, logout } = useEssentials()

    const { data, isLoading, isError, error, refetch } = useStoreTrailerEta({
        env,
        accessToken: session?.accessToken ?? '',
        filters: {
            move_id: moveId.moveId,
        },
    })

    const count = useCountdown(5, logout, error as Error)

    const getHeaderInfo = () => {
        const hasDeliveryInfo = data?.delivery_window_range_from
        const status = data?.status_message

        if (hasDeliveryInfo) {
            return (
                `${status} ${formatDate(data.delivery_window_range_from)} - ` +
                `${formatDate(data.delivery_window_range_to)}`
            )
        }
        return `${status} ${formatDate(data.status_timestamp)}`
    }

    const getStatus = (status: string) => {
        return status ? 'success' : 'default'
    }

    const formatDate = (date: string) => {
        return date ? format(parseISO(date), 'MMM d, h:mm a') : ''
    }

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="text" rows={1} />
            </div>
        )
    }

    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    return (
        <Accordion
            startOpen={false}
            preserveDom
            spacing="dense"
            headerSlot={<strong>{getHeaderInfo()}</strong>}
        >
            <Timeline>
                {data?.events.map((item: any, index: number) => (
                    <Timeline.Item
                        key={index}
                        title={item.description}
                        variant={getStatus(item.event_timestamp)}
                    >
                        {item.event_description}
                        {item.event_timestamp &&
                            ` |  ${formatDate(item.event_timestamp)}`}
                    </Timeline.Item>
                ))}
            </Timeline>
            <Grid.Item
                className="hc8-mt-3x"
                size={{
                    xs: 12,
                }}
            >
                <strong>{'From'}</strong>
            </Grid.Item>
            <Grid.Item
                size={{
                    xs: 12,
                }}
            >
                {data?.origin || ''}
            </Grid.Item>
        </Accordion>
    )
}
